<template>
  <v-layout row class="align-center layout px-4 pt-2 app--page-header">
    <!-- <div class="page-header-left">
      <h3 class="pr-3">{{ $t(title) }}</h3>
    </div> -->
    <v-breadcrumbs divider="/" :items="breadcrumbs"> </v-breadcrumbs>
    <v-spacer></v-spacer>
    <div class="page-header-right">
      <v-btn @click="reloadGruTable()" icon>
        <v-icon class="text--secondary">refresh</v-icon>
      </v-btn>
    </div>
  </v-layout>
</template>

<script>
import { menuService } from "@/services";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      title: ""
    };
  },
  computed: {
    ...mapGetters("menu", ["menuTree"]),
    breadcrumbs: function() {
      let breadcrumbs = [];
      this.menuTree.forEach(item => {
        if (item.href == "") {
          let grandChild = null;
          if (item.items == null) {
            //debugger;
            let a = 1;
          }
          let child = item.items.find(i => {
            //return i.component === this.$route.name;
            if (i.href == "" && i.items) {
              grandChild = i.items.find(grandItem => {
                return menuService.isMatched(grandItem.href, this.$route.path);
              });
              if (grandChild) {
                return true;
              }
              return false;
            } else {
              return menuService.isMatched(i.href, this.$route.path);
            }
          });
          if (child) {
            breadcrumbs.push({
              text: this.$i18n.t(item.title),
              href: item.href
            });
            breadcrumbs.push({
              text: this.$i18n.t(child.title),
              href: child.href,
              disabled: true
            });
            this.title = this.$i18n.t(child.title);
          }
          if (grandChild) {
            breadcrumbs.push({
              text: this.$i18n.t(grandChild.title),
              href: grandChild.href,
              disabled: true
            });
            this.title = this.$i18n.t(grandChild.title);
          }
        } else {
          if (menuService.isMatched(item.href, this.$route.path)) {
            this.title = this.$i18n.t(item.title);
            breadcrumbs.push({
              text: this.$i18n.t(item.title),
              href: item.href,
              disabled: true
            });
          }
        }
      });
      return breadcrumbs;
    }
  },
  methods: {
    reloadGruTable: function() {
      this.$root.$emit("gruTableSearch");
    }
  }
};
</script>
